<template>
	<div class="content-pad-vert content-pad-horizontal">
		<v-layout row wrap class="pa-0">
			<v-flex x12 sm10 md8 offset-sm1 offset-md2 class="pa-0 text-xs-center">
				<h1 class="mb-5">Saved Events and Wishlist</h1>
				<div
					style="color: #999"
					v-if="likedEvents.length == 0"
				>
					<p>Nothing to show</p>
				</div>
				<div style="width: 100%; display: flex; flex-flow: row wrap; justify-content: space-between;">
					<div class="saved-events__event-tile-flex mt-3" v-for="event in likedEvents" :key="event.pk">
						<event-list-item :event="event"></event-list-item>
					</div>
				</div>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EventListItem from '~/components/EventListItem.vue'

export default {
	methods: {
		...mapActions(['setModalOpen'])
	},
	computed: {
		...mapGetters(['getAllEvents', 'user']),
		likedEvents() {
			return this.getAllEvents.filter(
				obj => this.user.liked_events.indexOf(obj.pk) > -1
			)
		}
	},
	components: {
		EventListItem
	}
}
</script>

<style>
.saved-events__event-tile-flex {
	width: 48%;
	height: 350px;
	margin-bottom: 60px;
}

/* lg */
@media screen and (max-width: 1920px) {
	.saved-events__event-tile-flex {
		height: 300px;
	}
}

/* md */
@media screen and (max-width: 1280px) {
	.saved-events__event-tile-flex {
		height: 250px;
	}
}

/* sm */
@media screen and (max-width: 960px) {
	.saved-events__event-tile-flex {
		height: 300px;
		width: 100%;
	}
}

/* xs */
@media screen and (max-width: 599px) {
	.saved-events__event-tile-flex {
		width: 100%;
		height: 300px;
	}
}
</style>
